import { render, staticRenderFns } from "./RescheduleDataTable.vue?vue&type=template&id=0983ee60&scoped=true"
import script from "./RescheduleDataTable.vue?vue&type=script&lang=js"
export * from "./RescheduleDataTable.vue?vue&type=script&lang=js"
import style0 from "./RescheduleDataTable.vue?vue&type=style&index=0&id=0983ee60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0983ee60",
  null
  
)

export default component.exports